import classnames from "utilities/classnames";
import styles from "./styles.module.scss";
import { Link } from "react-router-dom";

type LegalLinksProps = {
  className?: string;
};

export function LegalLinks(props: LegalLinksProps) {
  const { className } = props;

  return (
    <>
      <div className={classnames(styles.root, className)}>
        <div className={styles.copyright}>
          © {new Date().getFullYear()} Flueid Software Corporation. All Rights Reserved.
        </div>
        <div className={styles.btns}>
          <Link to="/disclaimer" target="_blank">
            <u>Disclaimer</u>
          </Link>
          <Link to="/terms" target="_blank">
            <u>Terms of Use</u>
          </Link>
          <Link to="/privacy" target="_blank">
            <u>Privacy Policy</u>
          </Link>
        </div>
      </div>
    </>
  );
}
